<template>
  <l-cache :get-data="getRule" ref="cache" :id="$route.query.id">
    <violation-rule-form slot-scope="{data}" :rule="data">
      <template slot="title-actions">
        <v-btn @click="$refs.cache.retry()" flat color="primary" small>刷新</v-btn>
        <v-btn @click="goEdit(data)" flat color="primary" small>编辑</v-btn>
      </template>
    </violation-rule-form>
  </l-cache>
</template>

<script>

import ViolationRuleForm from './violationRuleForm'

export default {
  name: 'ViolationRuleDetails',
  components: {ViolationRuleForm},
  methods: {
    getParentCode (item) {
      let codes = item.code.split('_')
      if (codes.length < 2) {
        return 'root'
      }
      else {
        return codes.slice(0, -1).join('_')
      }
    },
    async getRule (key) {
      let {items} = await this.$store.dispatch('violation/getRules', {
        search: {key: 'id', value: key}
      })
      if (items.length) {
        return items[0]
      }
      else {
        throw Error('未找到该分组')
      }
    },
    goEdit (item) {
      this.$L.tab.close(this.$L.tab.current, false)
      this.$router.push({
        name: 'EditViolationRule',
        params: {name: item.name},
        query: {id: item.id, parent: this.getParentCode(item)}
      })
    }
  }
}
</script>

<style scoped>

</style>
